import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import AIWizard from "../../components/AIWizard";
import AIWizardSteps from "../../components/AIWizardStep";
import DetailsPrompt from "../../components/DetailsPrompt";
import GoalToneSelector from "../../components/GoalToneSelector";
import RoleSelector from "../../components/RoleSelector";
import { CreateContentContext } from "../context/CreateContentContext";
import useCreateContent from "../hooks/useCreateContent";
import ResultPanel from "./ResultPanel";

type Props = {
    onAccept: (updatedText: string) => void,
    onClose: () => void
}

const steps = ['Goals & Tone', 'Assistant Role', 'Details', 'Results']

const AIContentCreator = ({ onClose, onAccept }: Props) => {
    const [step, setStep] = useState(0);
    const { setGoalAndTone, setRole, chatRequest, goals, tones, roles, setPrompt } = useCreateContent();

    const handleClose = () => {
        onClose();
    }

    const handleNextStep = () => {
        if (step !== 3) {
            setStep(step => step + 1);
        } else {
            setStep(0);
            onClose();
        }
    }

    const handlePrevioewStep = () => {
        if (step !== 0) {
            setStep(step => step - 1);
        }
    }

    return (
        <AIWizard>
            <AIWizardSteps steps={steps} step={step} />

            <Grid item xs={8} md={8.5} sx={{ height: '100%', maxHeight: '100%' }}>
                {step === 0 && <GoalToneSelector
                    onNext={(goal, tone) => {
                        setGoalAndTone(goal, tone);

                        handleNextStep();
                    }}
                    onCancel={handleClose}
                    goal={chatRequest.goal}
                    tone={chatRequest.tone}
                    tones={tones}
                    goals={goals} />
                }
                {step === 1 && <RoleSelector
                    onNext={(role) => {
                        setRole(role);
                        handleNextStep();
                    }}
                    onPrevious={handlePrevioewStep}
                    onCancel={handleClose}
                    role={chatRequest.role}
                    roles={roles} />
                }
                {step === 2 && <DetailsPrompt
                    onNext={(text) => {
                        setPrompt(text);
                        handleNextStep();
                    }}
                    onCancel={handleClose}
                    onPrevious={(text) => {
                        setPrompt(text);
                        handlePrevioewStep();
                    }}
                    prompt={chatRequest.promptDetails}
                    contentType={chatRequest.contentType ? chatRequest.contentType.name.toLocaleLowerCase() : ''}
                />}

                {step === 3 && <ResultPanel
                    onFinish={handleNextStep}
                    onCancel={handleClose}
                    onPrevious={handlePrevioewStep}
                    onAccept={onAccept}
                />}
            </Grid>
        </AIWizard>
    )
}

export default AIContentCreator;